<template>
    <div v-if="item">
        <table class="table table-sm small text-muted mt-1" v-if="item.js_prescricao_horarios && item.js_prescricao_horarios.horarios && item.js_prescricao_horarios.horarios.length">
            <thead>
                <tr v-for="(horario, ihx) in item.js_prescricao_horarios.horarios" :key="ihx">
                    <td :width="blockw ? '' : '3%'">
                        <a href="#" @click.prevent="aplicar()" title="Registrar Aplicação">
                            <i :class="icon_hora_status(horario)" :title="texto_hora_status(horario)"></i>
                        </a>
                    </td>
                    <td :width="blockw ? '' : '17%'">
                        <template v-if="horario.hora && horario.hora.length > 10">
                            {{ $util.getFormatDate(horario.hora) }} {{ horario.hora.substr(11,5) }}
                        </template>
                        <template v-else>
                            {{ horario.hora }}
                        </template>
                    </td>
                    <td :width="blockw ? '' : '40%'">
                        <span v-if="horario.responsavel_atualizacao">
                            por
                            <template v-if="!Array.isArray(horario.responsavel_atualizacao)">
                                {{ $util.ucwords(horario.responsavel_atualizacao) }}
                            </template>
                            <template v-else
                                v-for="(responsavel, index) in horario.responsavel_atualizacao">
                                {{ index > 0 ? ' e ' : '' }}{{
                                $util.ucwords(responsavel.st_nome) }}

                                <span v-if="responsavel.conselho && responsavel.numero" :key="'c' + index" class="small text-muted ml-1">
                                    {{ responsavel.conselho }} {{ responsavel.numero }}
                                </span>
                            </template>
                        </span>
                    </td>
                    <td :width="blockw ? '' : '40%'">
                        {{ horario.obs }}
                    </td>
                </tr>
            </thead>
        </table>

        <div class="small text-muted mt-1" v-else>
            Nenhum horário aprazado.
        </div>
    </div>
</template>

<script>
export default {
    props: ['item', 'blockw'],

    methods: { 
        aplicar() {
            this.$emit('aplicar', this.item);
        },

        texto_hora_status (horario) { 
            if ( !horario && !horario.status )
                return;

            switch (horario.status) {
                case 'A': return 'Aberto';
                case 'X': return 'Checado';
                case 'R': return 'Rejeitado';
                case 'C': return 'Cancelado';
                case 'S': return 'Suspenso';
            }
        },

        icon_hora_status (horario) { 
            if ( !horario && !horario.status )
                return;

            switch (horario.status) {
                case 'A': return 'fa fa-question-circle';
                case 'X': return 'fa fa-check-circle text-success';
                case 'R': return 'fa fa-exclamation-circle text-warning';
                case 'C': return 'fa fa-times-circle text-danger';
                case 'S': return 'fa fa-ban text-danger';
            }
        },
    }
}
</script>
